var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNextDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 13,
    cy: 13,
    r: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24036 9.23383C9.55569 8.92207 10.0632 8.92206 10.3785 9.23382L12.4167 11.249C13.0942 11.9187 13.4329 12.2536 13.4329 12.6712C13.4329 13.0888 13.0942 13.4237 12.4167 14.0935L10.3785 16.1086C10.0632 16.4203 9.55569 16.4203 9.24036 16.1086C9.00732 15.8782 8.93621 15.53 9.06026 15.2266L9.7957 13.4282C9.9485 13.0546 10.0249 12.8678 10.0249 12.6712C10.0249 12.4746 9.9485 12.2878 9.7957 11.9142L9.06026 10.1158C8.93621 9.81243 9.00732 9.46423 9.24036 9.23383ZM14.2404 9.23383C14.5557 8.92207 15.0632 8.92206 15.3785 9.23382L17.4167 11.249C18.0942 11.9187 18.4329 12.2536 18.4329 12.6712C18.4329 13.0888 18.0942 13.4237 17.4167 14.0935L15.3785 16.1086C15.0632 16.4203 14.5557 16.4203 14.2404 16.1086C14.0073 15.8782 13.9362 15.53 14.0603 15.2266L14.7957 13.4282L14.7957 13.4282C14.9485 13.0546 15.0249 12.8678 15.0249 12.6712C15.0249 12.4746 14.9485 12.2878 14.7957 11.9142L14.7957 11.9142L14.0603 10.1158C13.9362 9.81243 14.0073 9.46423 14.2404 9.23383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextDouble);
export default __webpack_public_path__ + "static/media/icon-next-double.6fa0951e8cef82bc7c4d3adc7601a73a.svg";
export { ForwardRef as ReactComponent };